module.exports = __webpack_public_path__ + "f7744d5c03d36bf48e3160afbe128f4b.png";